import { put, take } from 'redux-saga/effects';
import { setLoginSuccess } from '../reducers/userDetailsSlice';
import withLoading from './loadingSaga';
import { getUserDetails } from '../common/components/UserDetails/actions';
import { getLanguages } from '../reducers/translationSlice';

export const POST_LOGIN_ACTIONS = 'POST_LOGIN_ACTIONS';

export function* postLoginActions() {
  while (true) {
    yield take(setLoginSuccess.type);

    yield* withLoading(function* () {
      try {
        yield put(getUserDetails());
        yield put(getLanguages());
      } catch (error) {
        console.error('Error in post-login actions:', error);
      }
    });
  }
}
